import api from './api.service';

export const offerLetterApi = {
  // Job Details
  getJobDetails: async (jobId) => {
    try {
      const response = await api.get(`/jobs/${jobId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting job details:', error);
      throw error.response?.data || error;
    }
  },

  // Template Management
  uploadTemplate: async (jobId, formData) => {
    try {
      const response = await api.post(`/offer-letter/jobs/${jobId}/offer-template`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading template:', error);
      throw error.response?.data || error;
    }
  },

  getTemplate: async (jobId) => {
    try {
      const response = await api.get(`/offer-letter/jobs/${jobId}/offer-template`);
      return response.data;
    } catch (error) {
      console.error('Error getting template:', error);
      throw error.response?.data || error;
    }
  },

  deleteTemplate: async (jobId) => {
    try {
      const response = await api.delete(`/offer-letter/jobs/${jobId}/offer-template`);
      return response.data;
    } catch (error) {
      console.error('Error deleting template:', error);
      throw error.response?.data || error;
    }
  },

  // Offer Generation
  getOfferFormData: async (resumeId) => {
    try {
      const response = await api.get(`/offer-letter/resumes/${resumeId}/offer-form-data`);
      return response.data;
    } catch (error) {
      console.error('Error getting offer form data:', error);
      throw error.response?.data || error;
    }
  },

  generateOffer: async (resumeId, offerData) => {
    try {
      const response = await api.post(`/offer-letter/resumes/${resumeId}/generate-offer`, offerData);
      return response.data;
    } catch (error) {
      console.error('Error generating offer:', error);
      throw error.response?.data || error;
    }
  },

  getOfferPreview: async (resumeId) => {
    try {
      const response = await api.get(`/offer-letter/resumes/${resumeId}/offer-preview`);
      return response.data;
    } catch (error) {
      console.error('Error getting offer preview:', error);
      throw error.response?.data || error;
    }
  },

  sendOffer: async (resumeId) => {
    try {
      const response = await api.post(`/offer-letter/resumes/${resumeId}/send-offer`);
      return response.data;
    } catch (error) {
      console.error('Error sending offer:', error);
      throw error.response?.data || error;
    }
  },

  updateOfferStatus: async (resumeId, status, response) => {
    try {
      const apiResponse = await api.put(`/offer-letter/resumes/${resumeId}/offer-status`, {
        status,
        response
      });
      return apiResponse.data;
    } catch (error) {
      console.error('Error updating offer status:', error);
      throw error.response?.data || error;
    }
  }
}; 